import { TabPageDefinition } from '@/components/tab-pages';

export const coachesTabs = (params: Record<string, string>): TabPageDefinition[] => {
  return [
    {
      label: 'General',
      linkProps: {
        to: '/teachers/$teacherId',
        params: { teacherId: params.teacherId },
      },
    },
    {
      label: 'Schedule',
      linkProps: {
        to: '/teachers/$teacherId/schedule',
        params: { teacherId: params.teacherId },
      },
    },
    {
      label: 'Future sessions',
      linkProps: {
        to: '/teachers/$teacherId/future-sessions',
        params: { teacherId: params.teacherId },
      },
    },
    {
      label: 'Past sessions',
      linkProps: {
        to: '/teachers/$teacherId/past-sessions',
        params: { teacherId: params.teacherId },
      },
    },
    {
      label: 'Student feedback',
      linkProps: {
        to: '/teachers/$teacherId/feedbacks',
        params: { teacherId: params.teacherId },
      },
    },
    {
      label: 'Review notes',
      linkProps: {
        to: '/teachers/$teacherId/review-notes',
        params: { teacherId: params.teacherId },
      },
    },
    {
      label: 'Payments',
      linkProps: {
        to: '/teachers/$teacherId/payments',
        params: { teacherId: params.teacherId },
      },
      dataTestId: 'teachers-tab-payments',
    },
    {
      label: 'Weekly teaching hours',
      linkProps: {
        to: '/teachers/$teacherId/weekly-teaching-hours',
        params: { teacherId: params.teacherId },
      },
    },
  ];
};

export const coachesSectionTabs = (): TabPageDefinition[] => {
  return [
    {
      label: 'All Teachers',
      linkProps: {
        to: '/teachers',
      },
    },
    {
      label: 'Teacher Announcements',
      linkProps: {
        to: '/teachers/announcement',
      },
    },
    {
      label: 'Missing zoom license',
      linkProps: {
        to: '/teachers/missing-zoom-license',
      },
    },
    {
      label: 'Missing Google Meet',
      linkProps: {
        to: '/teachers/missing-google-meet',
      },
    },
    {
      label: 'Google Meet TQ review',
      linkProps: {
        to: '/teachers/google-meet-tq-review',
      },
    },
    {
      label: 'TQ review',
      linkProps: {
        to: '/teachers/tq-review',
      },
    },
    {
      label: 'Onboarding',
      linkProps: {
        to: '/teachers/onboarding',
      },
    },
    {
      label: 'Teacher Pay',
      linkProps: {
        to: '/teachers/teacher-pay',
      },
    },
    {
      label: 'Availabilities',
      linkProps: {
        to: '/teachers/availabilities',
      },
    },
    {
      label: 'Availability overview',
      linkProps: {
        to: '/teachers/availability-overview',
      },
    },
    {
      label: 'Attendance',
      linkProps: {
        to: '/teachers/attendance',
      },
    },
  ];
};
